import { VehicleModel } from '@/lib/models/vehicle/types';

// Gets a vehicle TEU (typically a Ocean vehicle)
export const getVehicleTeu = (vehicle: VehicleModel): string => {
  const teu = vehicle?.featureSet?.oceanLiner?.teu;
  return teu ? `${teu.toLocaleString()} TEU` : '';
};
